import { apiFetch } from './api'

/**
 * Fetch a full reachout object by ID
 * @param {string} reachoutId - UUID of the reachout
 * @returns {Promise<Object>} Full reachout object with all fields
 */
export async function fetchReachout(reachoutId: string): Promise<object> {
  if (!reachoutId) throw new Error('reachoutId is required')
  return await apiFetch(`/reachouts/${reachoutId}`)
}

/**
 * Fetch a full CRM modification object by ID
 * @param {string} crmModId - UUID of the CRM modification
 * @returns {Promise<Object>} Full CRM modification object with all fields
 */
export async function fetchCrmModification(crmModId: string): Promise<object> {
  if (!crmModId) throw new Error('crmModId is required')
  return await apiFetch(`/crm_modifications/${crmModId}`)
}
